import PropTypes from 'prop-types';

import { calculatePercentageChange } from './utils';
import { graphCurrencyFormatter } from '../../graphs/utils';
import { AnalyticsMetric } from './AnalyticsMetric';

import styles from './AnalyticsMetrics.module.scss';

export function AnalyticsMetricAmountAndPercentage({
  title,
  tooltip,
  currency,
  value,
  valuePercentage,
  prevValue,
  prevValuePercentage,
  loading,
  isOppositeTrend,
}) {
  const percentageChange = calculatePercentageChange(value, prevValue);

  const displayValue = (
    <>
      {graphCurrencyFormatter(Number(value) / 100, currency)}
      <span className={styles.separator} />
      {Number(valuePercentage).toFixed(1)}%
    </>
  );

  const displayPrevValue =
    !isNaN(prevValue) && prevValue > 0 ? (
      <>
        {graphCurrencyFormatter(Number(prevValue) / 100, currency)}
        <span className={styles.separator} />
        {Number(prevValuePercentage).toFixed(1)}%
      </>
    ) : undefined;

  return (
    <AnalyticsMetric
      title={title}
      tooltip={tooltip}
      value={displayValue}
      prevValue={displayPrevValue}
      percentageChange={percentageChange}
      isOppositeTrend={isOppositeTrend}
      loading={loading}
    />
  );
}

AnalyticsMetricAmountAndPercentage.propTypes = {
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  currency: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  valuePercentage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  prevValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  prevValuePercentage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isOppositeTrend: PropTypes.bool,
  loading: PropTypes.bool,
};
